import { formatTimestamp } from '@services/utils.service';

import './admin-last-update.styl';

function AdminLastUpdate({
  updatedAt,
  updatedBy,
  verified,
  isAdmin,
}) {
  if (!updatedAt) {
    return (
      <p className="admin-last-update">
        Deze informatie is afkomstig van de federale diagnostiek van het woon-werkverkeer (FOD Mobiliteit) en kan door u aangepast/aangevuld worden.
      </p>
    );
  }

  return (
    <p className="admin-last-update">
      {`Laatste update: ${formatTimestamp(updatedAt)}${updatedBy ? ` door ${updatedBy}${verified === false ? ' (jobcoach)' : ''}` : ''}`}
      <br />
      {isAdmin && verified === false && 'Een jobcoach vulde deze data aan, maar dit werd nog niet door uw bedrijf nagekeken.'}
    </p>
  );
}

export default AdminLastUpdate;